import { render, staticRenderFns } from "./ProfileCropper.vue?vue&type=template&id=2b0ae413&"
import script from "./ProfileCropper.vue?vue&type=script&lang=js&"
export * from "./ProfileCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports